import { jsx as _jsx } from "react/jsx-runtime";
import { DialogTitleWithIcon } from './DialogTitle.styled';
const DialogTitle = (props) => {
    return _jsx(DialogTitleWithIcon, { ...props });
};
export { DialogTitle };
